import { render, staticRenderFns } from "./TextSettingsModal.vue?vue&type=template&id=33ece6b6"
import script from "./TextSettingsModal.vue?vue&type=script&lang=js"
export * from "./TextSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TextSettingsModal.vue?vue&type=style&index=0&id=33ece6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports